import { jsx as _jsx } from "react/jsx-runtime";
import { styled } from "../../theme";
const RedSpan = styled.span `
  color: ${({ theme }) => theme.color.errorRed};
`;
export const RedTextRenderer = ({ children }) => (_jsx(RedSpan, { children: children }));
